import {
  Activity,
  Flag,
  Home,
  Search,
  MessageSquare,
  User,
  TrendingUp,
  Dumbbell,
  Trophy,
  FileText,
  Send,
  BarChart3,
  Users,
  Shield,
  Calendar,
  ClipboardList,
  Heart,
  HeartPulse,
  Award,
  Settings,
  UserCog,
  AlertCircle,
  DollarSign,
  CheckSquare,
  FileCheck,
  Briefcase,
  TrendingUp as TrendingUpIcon,
  CreditCard,
  Ticket,
  UserPlus,
  UserCheck,
  UserSearch,
  Club,
  Star,
  ClubIcon,
  Building,
  Stars,
  LetterText,
  LetterTextIcon,
} from "lucide-react";
import { AppRole } from "@/config/roles";

export interface NavItem {
  path: string;
  label: string;
  icon: any;
  isUnderConstruction?: boolean;
}

const fanPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/fan/events",
    label: "Events",
    icon: Ticket,
  },
  {
    path: "/fan/subscribe",
    label: "Subscribe",
    icon: Star,
    isUnderConstruction: true,
  },
];

const playerPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  { path: "/player/my-profile", label: "My Player Profile", icon: Star },
  { path: "/player/club", label: "Club", icon: Building },
  {
    path: "/player/trial-invitations",
    label: "Trial Invitations",
    icon: UserPlus,
  },
  { path: "/player/applications", label: "Applications", icon: FileText },
  {
    path: "/player/leaderboard",
    label: "Leaderboard",
    icon: Trophy,
  },
  { path: "/player/development", label: "Development", icon: TrendingUp },
  { path: "/consents", label: "Privacy", icon: Shield },
  { path: "/player/training", label: "Training", icon: Dumbbell },
  { path: "/player/welfare", label: "Welfare", icon: HeartPulse },
  {
    path: "/player/matches",
    label: "Matches",
    icon: Trophy,
  },
  {
    path: "/player/health",
    label: "Health",
    icon: Heart,
    isUnderConstruction: true,
  },
  {
    path: "/player/billing",
    label: "Billing",
    icon: CreditCard,
    isUnderConstruction: true,
  },
];

const coachPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  { path: "/onboarding", label: "Getting started", icon: CheckSquare },
  { path: "/coach/my-profile", label: "My Coach Profile", icon: Star },
  { path: "/coach/development", label: "Evaluations", icon: ClipboardList },
  {
    path: "/coach/trial-participants",
    label: "Trial Participants",
    icon: UserCheck,
    isUnderConstruction: true,
  },
  {
    path: "/coach/training-management",
    label: "Training",
    icon: Dumbbell,
    isUnderConstruction: true,
  },
  { path: "/club/players", label: "Players", icon: Users },
  { path: "/coach/welfare", label: "Player Welfare", icon: HeartPulse },
  {
    path: "/coach/player-performance",
    label: "Performance",
    icon: BarChart3,
    isUnderConstruction: true,
  },
  {
    path: "/coach/squad-management",
    label: "Squad",
    icon: Users,
    isUnderConstruction: true,
  },
  {
    path: "/coach/recommendations",
    label: "Scout Recommendations",
    icon: Search,
    isUnderConstruction: true,
  },
];

const clubOwnerPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  { path: "/onboarding", label: "Getting started", icon: CheckSquare },
  { path: "/owner/my-club", label: "My Club", icon: Star },
  { path: "/owner/players", label: "Players", icon: Users },
  { path: "/owner/programs", label: "Programs", icon: Shield },
  { path: "/club/roster", label: "Roster", icon: Users },
  { path: "/owner/staff", label: "Staff", icon: UserCog },
  { path: "/welfare/staff", label: "Assign staff", icon: UserCog },
  { path: "/club/match-ops", label: "Matches", icon: Trophy },
  { path: "/owner/applications", label: "Applications", icon: FileText },
  { path: "/owner/trial-invitations", label: "Trial Invitations", icon: Send },
  {
    path: "/club/finance",
    label: "Finance",
    icon: DollarSign,
  },
  {
    path: "/club/player-payments",
    label: "Player Payments",
    icon: CreditCard,
  },
  {
    path: "/club/scouter-marketplace",
    label: "Scouter Marketplace",
    icon: UserSearch,
    isUnderConstruction: true,
  },
  {
    path: "/owner/scouter-contracts",
    label: "Scouter Contracts",
    icon: FileText,
    isUnderConstruction: true,
  },
  {
    path: "/owner/scouting-reports",
    label: "Scouting Reports",
    icon: Search,
    isUnderConstruction: true,
  },
  {
    path: "/owner/reports",
    label: "Reports",
    icon: BarChart3,
    isUnderConstruction: true,
  },
];

const scoutPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/scout/talent-search",
    label: "Talent Search",
    icon: Search,
  },
  { path: "/scout/vetting", label: "Vetting", icon: Shield },
  { path: "/scout/shortlists", label: "Shortlists", icon: ClipboardList },
  {
    path: "/scout/reports",
    label: "Reports",
    icon: FileText,
    isUnderConstruction: true,
  },
  {
    path: "/scout/recommendations",
    label: "Recommendations",
    icon: Award,
    isUnderConstruction: true,
  },
  {
    path: "/scout/trial-tracking",
    label: "Trial Tracking",
    icon: TrendingUp,
    isUnderConstruction: true,
  },
];

const scouterPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/scouter/contracts",
    label: "Contracts",
    icon: Briefcase,
    isUnderConstruction: true,
  },
  {
    path: "/scouter/profile-settings",
    label: "Profile",
    icon: User,
    isUnderConstruction: true,
  },
  {
    path: "/scouter/performance",
    label: "Performance",
    icon: BarChart3,
    isUnderConstruction: true,
  },
];

const refereePages: NavItem[] = [
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/referee/assignments",
    label: "My Matches",
    icon: Calendar,
  },
  {
    path: "/referee/result-entry",
    label: "Result Entry",
    icon: ClipboardList,
  },
  { path: "/referee/profile", label: "Profile", icon: UserCog },
  { path: "/referee/open-games", label: "Open games", icon: Trophy },
  { path: "/referee/discipline", label: "Discipline", icon: ClipboardList },
];

const medicalPages: NavItem[] = [
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/medical/injuries",
    label: "Injuries",
    icon: Heart,
  },
  {
    path: "/medical/clearances",
    label: "Clearances",
    icon: ClipboardList,
  },
  { path: "/medical/analytics", label: "Injury analytics", icon: BarChart3 },
  { path: "/medical/welfare", label: "Player Welfare", icon: HeartPulse },
];

const venueOwnerPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/onboarding",
    label: "Getting started",
    icon: CheckSquare,
  },
  {
    path: "/venue/bookings",
    label: "Bookings",
    icon: Calendar,
    isUnderConstruction: true,
  },
  {
    path: "/venue/pricing",
    label: "Pricing",
    icon: DollarSign,
    isUnderConstruction: true,
  },
  {
    path: "/venue/insights",
    label: "Insights",
    icon: TrendingUpIcon,
    isUnderConstruction: true,
  },
];

const tournamentOrganizerPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  {
    path: "/organizer/new",
    label: "Create Tournament",
    icon: Trophy,
    isUnderConstruction: true,
  },
  {
    path: "/organizer/brackets",
    label: "Brackets",
    icon: Trophy,
    isUnderConstruction: true,
  },
];

const teamManagerPages: NavItem[] = [
  { path: "/team-manager/dashboard", label: "Dashboard", icon: Users },
  { path: "/team-manager/match-coordination", label: "Match Coordination", icon: Calendar },
  { path: "/team-manager/volunteers", label: "Volunteers", icon: UserPlus },
  { path: "/team-manager/welfare", label: "Player Welfare", icon: HeartPulse },
  { path: "/club/players", label: "Players", icon: Users },
  { path: "/team-manager/posts", label: "Posts & Highlights", icon: Send },
  { path: "/team-manager/analytics", label: "Analytics", icon: BarChart3 },
  { path: "/team-manager/club-page", label: "Club Page", icon: Home },
  { path: "/team-manager/media", label: "Media Gallery", icon: Send },
  { path: "/team-manager/reports", label: "Reports", icon: BarChart3 },
  { path: "/medical/analytics", label: "Injury analytics", icon: BarChart3 },
];

const adminPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/admin/approval-center", label: "Approvals", icon: ClipboardList },
  { path: "/admin/national-id", label: "Verification", icon: FileCheck },
  { path: "/admin/user-management", label: "Users", icon: Users },
  { path: "/admin/safeguarding", label: "Safeguarding", icon: Shield },
  { path: "/admin/pdpa", label: "PDPA", icon: FileCheck },
  { path: "/admin/ops", label: "Operations", icon: BarChart3 },
  { path: "/admin/moderation", label: "Moderation", icon: AlertCircle },
  { path: "/admin/system-reports", label: "Reports", icon: BarChart3 },
];

const superAdminPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/admin/approval-center", label: "Approvals", icon: ClipboardList },
  { path: "/admin/user-management", label: "Users", icon: Users },
  { path: "/super/admin-management", label: "Admins", icon: Shield },
  { path: "/super/roles-permissions", label: "Roles", icon: Shield },
  {
    path: "/super/subscriptions/dashboard",
    label: "Subscriptions",
    icon: CreditCard,
  },
  { path: "/admin/moderation", label: "Moderation", icon: AlertCircle },
  { path: "/super/ai-control", label: "AI Control", icon: BarChart3 },
  { path: "/super/feature-flags", label: "Feature Flags", icon: Flag },
  { path: "/super/monitoring", label: "Monitoring", icon: Activity },
  { path: "/super/content/translations", label: "Translations", icon: LetterText },
  { path: "/super/audit-logs", label: "Audit Logs", icon: ClipboardList },
  { path: "/admin/system-reports", label: "Analytics", icon: TrendingUpIcon },
  { path: "/admin/national-id", label: "ID Verification", icon: FileCheck },
  { path: "/super/financial", label: "Financial", icon: DollarSign },
  { path: "/super/integrations", label: "Integrations Config", icon: Settings },
  ...(import.meta.env.DEV
    ? [{
        path: "/super/integration-test",
        label: "Integrations Test",
        icon: CheckSquare,
      }]
    : []),
  { path: "/super/refunds", label: "Refund Center", icon: ClipboardList },
  { path: "/super/content", label: "Content Management", icon: FileText },
  {
    path: "/super/content/footer",
    label: "Footer Management",
    icon: ClipboardList,
  },
  { path: "/super/system-settings", label: "Settings", icon: Settings },
  ...(import.meta.env.DEV
    ? [{ path: "/super/page-validator", label: "Page Specs", icon: CheckSquare }]
    : []),
];

const parentPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
  { path: "/onboarding", label: "Getting started", icon: CheckSquare },
  { path: "/consents", label: "Consent", icon: Shield },
  { path: "/children", label: "Children", icon: Users },
  { path: "/parent/household", label: "Household", icon: Users },
  { path: "/parent/welfare", label: "Player Welfare", icon: HeartPulse },
  { path: "/children/player-profile", label: "Player Profiles", icon: Stars },
  { path: "/parent/schedule", label: "Schedule", icon: Calendar },
  { path: "/player/applications", label: "Applications", icon: FileText },
];

const clubAdminPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
];

const clubManagerPages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
];

const clubFinancePages: NavItem[] = [
  { path: "/dashboard", label: "Dashboard", icon: Home },
  { path: "/explore", label: "Explore", icon: Search },
  { path: "/favorites", label: "Favorites", icon: Heart },
];

// Shared pages accessible to multiple roles
const sharedPages: NavItem[] = [
  { path: "/social", label: "Social", icon: Users },
];

const roleNavigationMap: Record<AppRole, NavItem[]> = {
  fan: fanPages,
  player: playerPages,
  coach: coachPages,
  club_owner: clubOwnerPages,
  scout: scoutPages,
  scouter: scouterPages,
  referee: refereePages,
  medical_staff: medicalPages,
  venue_owner: venueOwnerPages,
  tournament_organizer: tournamentOrganizerPages,
  team_manager: teamManagerPages,
  admin: adminPages,
  super_admin: superAdminPages,
  club_admin: clubAdminPages,
  club_manager: clubManagerPages,
  club_finance: clubFinancePages,
  parent: parentPages,
};

export const getNavigationForRole = (role: AppRole): NavItem[] => {
  return roleNavigationMap[role] || fanPages;
};

export const switchableRoles: AppRole[] = [
  "player",
  "coach",
  "club_owner",
  "scout",
  "scouter",
  "venue_owner",
  "tournament_organizer",
  "team_manager",
  "referee",
  "medical_staff",
  "parent",
  "club_admin",
  "club_manager",
  "club_finance",
];
